import React from 'react'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Stack from 'components_new/atoms/Stack'
import Text from 'components_new/atoms/Text'

interface FormulaBoxProps {
  formula: string
  note: string | null
}

/**
 * The definition spelled out, so it can be read against a reference
 * calculation before anyone publishes it.
 */
const FormulaBox = (props: FormulaBoxProps) => {
  const { formula, note } = props

  return (
    <Box
      sx={{
        bgcolor: 'action.hover',
        borderRadius: 1,
        p: 2
      }}
    >
      <Text color="text.secondary" gutterBottom={true} variant="overline">
        Formel
      </Text>
      <Box
        sx={{
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          fontFamily: 'monospace',
          fontSize: '0.85rem',
          overflowX: 'auto',
          p: 1.5
        }}
      >
        {formula}
      </Box>
      {note ? (
        <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5, mt: 1 }}>
          <Icon fontSize="small" name="Info" />
          <Text color="text.secondary" variant="caption">
            {note}
          </Text>
        </Stack>
      ) : null}
    </Box>
  )
}

export default FormulaBox
